import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router-dom'

import API from '../api'

import FaSearch from 'react-icons/fa/search'
import FaBookmark from 'react-icons/fa/bookmark'
import FaStar from 'react-icons/fa/star'
import FaChevronDown from 'react-icons/fa/chevron-down'
import FaAgeGroup from 'react-icons/fa/birthday-cake'

import SearchInput from './SearchInput'
import { SubscriptionPolicy } from 'pobble-components/dist/subscriptions'

const ExemplarsButton = ({active, onChange, checked, disabled, onClick}) => (
  <label
    onClick={onClick}
    style={{backgroundColor: disabled ? '#f1f4f9' : 'transparent'}}
    htmlFor='filterExemplar'
    className={`search__filter search__filter--btn ${active ? 'search__filter--active' : ''}`}>
    Exemplars
    <input onClick={onClick} id='filterExemplar' type='checkbox' onChange={onChange} checked={checked} disabled={disabled} />
  </label>
)

@autobind
class SearchHeader extends Component {
  constructor (props) {
    super(props)
    this.state = { query: '', year_groups: [], filters: this.props.filters }
  }

  componentDidMount () {
    API.get('/v3/year_groups?include=year_group.names,year_group.order').then(({data}) => this.setState({year_groups: data.year_groups}))
  }

  handleSubmit (event) {
    event.preventDefault()
    this.props.onSubmit(this.state.query)
  }

  handleInputChange (query) {
    this.setState({ query })
  }

  toggleFilter (type) {
    return (e) => this.props.onFilterSelect({ [type]: e.target.value })
  }

  toggleBookmark (e) {
    this.props.onFilterSelect({ bookmark: e.target.checked })
  }

  toggleExemplar (e) {
    this.props.onFilterSelect({ exemplar: e.target.checked })
  }

  clearFilter () {
    this.props.onFilterSelect({bookmark: false, exemplar: false, yeargroup: false})
  }

  render () {
    var yearGroupFilter = this.state.year_groups.map(group => <option key={group.id} value={group.id}>{group.title}</option>)
    var schoolGroupsFilter = this.props.school.groups && this.props.school.groups.filter(group => group.visibility === 'public' && group.number_of_students).map(group => <option key={group.id} value={group.id}>{group.title}</option>)
    var groups = this.props.school.groups && <div className={`search__filter search__filter__groups select ${this.props.filters.groupId ? 'select--active' : ''}`}>
      <select className='select__box' onChange={this.toggleFilter('groupId')}>
        <option value=''>All groups</option>
        {schoolGroupsFilter}
      </select>
      <FaChevronDown className='select__arrow' />
    </div>
    var studentFilters = this.props.user.student_type && <div className='search__filter select'>
      <select className='select__box' onChange={this.toggleFilter('student')}>
        <option value=''>The World</option>
        <option value='student_id'>My writing</option>
        <option value='school_id'>In my school</option>
      </select>
      <FaChevronDown className='select__arrow' />
    </div>

    var bookmark = this.props.user.id && <label htmlFor='filterBookmark' className={`search__filter search__filter--btn ${this.props.filters.bookmark ? 'search__filter--active' : ''}`}>
      Bookmarks
      <input id='filterBookmark' type='checkbox' onChange={this.toggleBookmark} checked={this.state.filters.bookmark} />
    </label>

    var clearFiltersBtn = <button onClick={this.clearFilter} className='search__filter--btn search__filter search__filter--clear'>Clear</button>

    return (
      <form name='searchForm' className='search-header' onSubmit={this.handleSubmit}>
        <SearchInput onChange={this.handleInputChange} {...this.props} />
        <button type='submit'><FaSearch /></button>
        <div className={`search__filters ${this.props.school.groups ? 'search__filters--school' : ''}`}>
          <div className='search__filters__label'>Filter by </div>
          {/*{groups}*/}
          {studentFilters}
          {bookmark}
          {/*<SubscriptionPolicy policy={sp => sp.filter_exemplars}>
            {filterExemplarsSp => !this.props.user.student_type && filterExemplarsSp.restricted ? (
              <ExemplarsButton disabled onClick={filterExemplarsSp.showDialog} />
            ) : (
              <ExemplarsButton
                active={this.props.filters.exemplar}
                onChange={this.toggleExemplar}
                checked={this.state.filters.exemplar} />
            )}
          </SubscriptionPolicy>*/}
          <div className={`search__filter select ${this.props.filters.yeargroup ? 'select--active' : ''}`}>
            <select className='select__box' onChange={this.toggleFilter('yeargroup')}>
              <option value='' defaultValue={!this.props.filters.yeargroup}>All ages</option>
              {yearGroupFilter}
            </select>
            <FaChevronDown className='select__arrow' />
          </div>
          {(this.props.filters.bookmark || this.props.filters.exemplar || this.props.filters.yeargroup) && clearFiltersBtn}
          <div className='search__filters__label'>Sort by</div>
          <div className='search__filter select'>
            <select className='select__box' onChange={this.toggleFilter('order')}>
              <option value='published_at'>Latest</option>
              <option value='views'>Views</option>
            </select>
            <FaChevronDown className='select__arrow' />
          </div>
        </div>
      </form>
    )
  }
}

SearchHeader.propTypes = {
  filters: PropTypes.object,
  onFilterSelect: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  school: PropTypes.object,
  user: PropTypes.object
}

export default SearchHeader



// WEBPACK FOOTER //
// ./components/search/SearchHeader.js